import { apiConfig as config, request } from '@/shared/io';
// 获取轮播图列表
export async function getQueryAd(data) {
    return request(`${config.apiCms}/v1/ad/theme/queryAd/code/${data.code}/channel/${data.channel}`, {
        method: 'get',
    });
}
// 获取记录-根据业务ids、业务code
export async function getFileInfoByBusIds(data) {
    return request(`${config.apiOss}/v1/file/info/bus/ids/code`, {
        method: 'post',
        data,
    });
}
// 获取最新置顶的一条公告
export async function getTopNotice() {
    return request(`${config.apiCms}/v1/cms/content/topNotice?noticeType=1`, {
        method: 'GET',
    });
}
// 更新公告不在置顶
export async function updateTopNoticeById(contentId) {
    return request(`${config.apiCms}/v1/cms/promptRecord/topNotice/${contentId}`, {
        method: 'put',
        headers: {
            'depend-uri': `${config.apiCms}/v1/cms/content/popupContent`,
            'depend-method': 'GET',
        },
    });
}
// 个人信息
export async function getMyMessage() {
    return request(`${config.apiUims}/v1/org/my`, {
        method: 'GET',
    });
}
// 获取应用系统
export async function getSystemList() {
    return request(`${config.apiUims}/v1/system/list/1`, {
        method: 'get',
    });
}
// 应用分类列表
export async function systemTypeGetAll(headers = {}) {
    return request(`${config.apiUims}/v1/oss/systemType/getAll`, {
        method: 'get',
        headers,
    });
}
// 检查是否可以访问系统
export async function checkSystem(data, headers = {}) {
    return request(`${config.apiUims}/v1/checkSystem/${data}`, {
        method: 'get',
        headers,
    });
}
// 检查是否可以访问系统
export async function homeStatistics(headers = {}) {
    return request(`${config.apiBg}/v1/project/home/statistics`, {
        method: 'get',
        headers,
    });
}
// 通知公告列表
export async function getNoticePage(data) {
    return request(`${config.apiCms}/v1/cms/content/notice/page`, {
        method: 'post',
        data,
    });
}
// 流程待办统计
export async function taskCount(data) {
    return request(`${config.activiti}/v1/home/custom/${data.module}/taskCount?companyId=${data.companyId}`, {
        method: 'get',
    });
}
// 待办事项列表
export async function tasksCustom(data) {
    return request(`${config.activiti}/v1/tasks/custom/${data.module}/${data.page}/${data.size}?businessName=${data.businessName}&projectId=${data.projectId}&companyId=${data.companyId}`, {
        method: 'get',
    });
}
// 已办、已完结、我参与的列表
export async function taskCustomFinished(data) {
    return request(`${config.activiti}/v1/historic-task-instances/custom/finished/${data.type}/${data.module}/${data.page}/${data.size}?businessName=${data.businessName}&projectId=${data.projectId}&companyId=${data.companyId}`, {
        method: 'get',
    });
}
//站内信邀请详情
export async function todoTaskUrl() {
    return request(`${config.apiUims}/v1/quick/entrance/todoTaskUrl`, {
        method: 'get',
    });
}
// 获取通知公告不在显示
export async function setPopupContentDisable(id) {
    return request(`${config.apiCms}/v1/cms/promptRecord/noPrompt/${id}`, {
        method: 'put',
        headers: {
            'depend-uri': `${config.apiCms}/v1/cms/content/popupContent`,
            'depend-method': 'GET',
        },
    });
}
// 获取通知公告弹窗设置
export async function getPopupContent() {
    return request(`${config.apiCms}/v1/cms/content/popupContent`, {
        method: 'get',
    });
}
// 我的企业
export async function userCompany() {
    return request(`${config.apiUims}/v1/org/user/company`, {
        method: 'get',
    });
}
// 注册公司
export async function companyRegister(data) {
    return request(`${config.apiUims}/v1/user/company/register`, {
        method: 'post',
        data,
    });
}
// 切换我的企业
export async function putCompany(data) {
    return request(`${config.apiUims}/v1/org/default/company`, {
        method: 'put',
        data,
    });
}
// 设置我的主企业
export async function setMainCompany(data) {
    return request(`${config.apiUims}/v1/org/main/company`, {
        method: 'put',
        data,
    });
}
// 根据父级id查询省市区
export async function getAreaList(data) {
    return request(`${config.apiUims}/v1/area/lowerTable/${data}`, {
        method: 'get',
    });
}
// 新增企业
export async function registerCompany(data, headers = {}) {
    return request(`${config.apiUims}/v1/user/company/register`, {
        method: 'post',
        data,
        headers,
    });
}
// 编辑企业
export async function editCompany(data, headers = {}) {
    return request(`${config.apiUims}/v1/company`, {
        method: 'put',
        data,
        headers,
    });
}
